import React from "react";

// react router component
import { useEffect, useRef, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

// pages
import Login from "./authentication/Login";
import AdminLogin from "./authentication/AdminLogin";

// Employee Master
import AddEmployee from "./pages/HrMaster/EmployeeMaster/AddEmployee";
import ListEmployee from "./pages/HrMaster/EmployeeMaster/ListEmployee";
import ViewEmployee from "./pages/HrMaster/EmployeeMaster/ViewEmployee";



//product Master
// import AddProduct from "./pages/ProductMaster/ProductMasterAdd.jsx";

// Advance Payment
import AdvancePayment from "./pages/HrMaster/AdvancePayment/AdvancePaymentAdd";
import AdvancePaymentEdit from "./pages/HrMaster/AdvancePayment/AdvancePaymentEdit";
import AdvancePaymentView from "./pages/HrMaster/AdvancePayment/AdvancePaymentEdit";
import AdvancePaymentList from "./pages/HrMaster/AdvancePayment/AdvancePaymentList";

// LeaveMaster
import ApplyLeave from "./pages/HrMaster/LeaveMaster/ApplyLeave";
import ApproveLeave from "./pages/HrMaster/LeaveMaster/ApproveLeave";

// Project Mater
import ProjectMasterAdd from "./pages/ProjectMaster/ProjectMasterAdd";
import ProjectMasterList from "./pages/ProjectMaster/ProjectMasterList";
import ProjectMasterEdit from "./pages/ProjectMaster/ProjectMasterEdit";

// Client Master
import ClientMasterAdd from "./pages/ClientMaster/ClientMasterAdd";
import ClientMasterList from "./pages/ClientMaster/ClientMasterList";
import ClientMasterEdit from "./pages/ClientMaster/ClientMasterEdit";

// PositionMaster
import AddPositons from "./pages/OtherMasters/PositionMaster/AddPositionMaster";

//DepartmentMaster
import AddDepartments from "./pages/OtherMasters/DepartmentMaster/AddDepartments";

//ContractorMaster
// import AddContract from "./pages/ContractorMaster/AddContractor";
// import ListContractor from "./pages/ContractorMaster/ListContractor";

//HolidayMaster
import AddHolidayDay from "./pages/OtherMasters/HolidayMaster/AddHoliday";

//Pomaster
import PurchaseOrderView from "./pages/VendorMaster/PoMaster/PurchaseOrderView";
import PurchaseOrderList from "./pages/VendorMaster/PoMaster/PurchaceOrderList";
import PurchaseOrderEdit from "./pages/VendorMaster/PoMaster/PurchaseOrderEdit";

//VendorMaster
import VendorCreate from "./pages/VendorMaster/VendorMaster/VendorCreate";
import VendorList from "./pages/VendorMaster/VendorMaster/VendorList";
import VendorEdit from "./pages/VendorMaster/VendorMaster/VendorEdit";

//PaymentRequestProject
import PaymentRequest from "./pages/PaymentRequest/PaymentRequest";
import PaymentRequestApproval from "./pages/PaymentRequest/PaymentRequestApproval";
import ListPaymentRequest from "./pages/PaymentRequest/PaymentRequestList";
import PaymentRequestView from "./pages/PaymentRequest/PaymentRequestView";

//Terms and Conditions
import TermsConditions from "./pages/OtherMasters/TermsConditions/TermsConditions";
import TermsConditionsList from "./pages/OtherMasters/TermsConditions/TermsConditionsList";
import TermsConditionsEdit from "./pages/OtherMasters/TermsConditions/TermsConditionsEdit";

// Role Mater
import RequireAuth from "./authentication/RequireAuth";

//Pay Slip
import PaySlip from "./pages/PayslipMaster/PaySlip";
import PayslipReport from "./pages/PayslipMaster/payslipReport";

//Allowances
import ManageAllowances from "./pages/OtherMasters/ManageAllowances/ManageAllowances";

//Attendance Master
import EmployeeAttendance from "./pages/AttendanceMaster/employeeAttendance";
import EmployeeAttendanceReport from "./pages/AttendanceMaster/employeeAttendanceReport";

import LabourAttandence from "./pages/UserMaster/LabourAttandence";
import LabourAttend from "./pages/AttendanceMaster/labourAttendence";
//User Master
import UserAttendance from "./pages/UserMaster/UserAttendance";

//Dashboard
import DashboardRouter from "./pages/DashboardRouter";
import PageNotFound from "./pages/PageNotFound";

// Announcement
import Announcement from "./pages/AnnouncementMaster/AnnouncementMaster.jsx";

// css
import "./App.css";
import "./assets/css/tableEnhancements.css";

// keeps list/report row heights consistent, contains horizontal table
// scrolling, and reveals clipped cell content on click (mounted once)
import TableCellExpander from "./components/TableCellExpander";

// Other
import { userData, FrontentUrl } from "./config";

//Test
import Pagination from "./pages/Pagination";
import ProjectIncome from "./pages/ProjectMaster/ProjectIncome";
import Invoice from "./pages/InvoiceMaster/Invoice";
import ManageCoAdd from "./pages/ManageCompanies/ManageCoAdd";
import InvoiceTermsCondition from "./pages/InvoiceTermsAndConditions/InvoiceTermsCondition";
import InvoiceTermsConditionList from "./pages/InvoiceTermsAndConditions/InvoiceTermsConditionList";
import ManageCoList from "./pages/ManageCompanies/ManageCoList";
import ManageCoEdit from "./pages/ManageCompanies/ManageCoEdit";
import InvoiceTermsConditionEdit from "./pages/InvoiceTermsAndConditions/InvoiceTermsConditionEdit";
import InvoiceList from "./pages/InvoiceMaster/InvoiceList";
import InvoiceView from "./pages/InvoiceMaster/InvoiceView";
import ProjectSummaryReport from "./pages/reports/ProjectSummaryReport";
import ProjectReport from "./pages/reports/ProjectReport";
import LeaveReport from "./pages/reports/LeaveReport";
import EmployeeActivityReport from "./pages/reports/EmployeeActivityReport";
import AttendanceReport from "./pages/reports/EmployeeAttendanceReport";
import ProjectPaymentReport from "./pages/reports/ProjectPaymentReport";

import Configuration from "./pages/OtherMasters/ConfigurationMaster/Configuration";
import LabourWages from "./pages/OtherMasters/ConfigurationMaster/LabourWages";
import LabourWagesEdit from "./pages/OtherMasters/ConfigurationMaster/LabourWagesEdit";

import PaymentRequestList from "./pages/PaymentRequest/PaymentRequestList";

import storeMasterAdd from "./pages/OtherMasters/StoreMaster/StoreMasterAdd.jsx";
import StoreMasterAdd from "./pages/OtherMasters/StoreMaster/StoreMasterAdd.jsx";
import StoreMasterList from "./pages/OtherMasters/StoreMaster/StoreMasterList";
import StoreMasterEdit from "./pages/OtherMasters/StoreMaster/StoreMasterEdit";
import InvoiceEdit from "./pages/InvoiceMaster/InvoiceEdit";
import Products from "./pages/ProductMaster/Products.jsx";
import BundleProduct from "./pages/ProductMaster/BundleProduct.jsx";
import ListProduct from "./pages/ProductMaster/ProductList.jsx";
import Orders from "./pages/OrderMaster/Orders.jsx";
import ProformaInvoice from "./pages/OrderMaster/ProformaInvoice.jsx";
import ProformaInvoiceList from "./pages/OrderMaster/ProformaInvoiceList.jsx";
import ProformaInvoiceHistory from "./pages/OrderMaster/ProformaInvoiceHistory.jsx";
import GenerateGrn from "./pages/OrderMaster/GenerateGrn.jsx";
import ListOrder from "./pages/OrderMaster/OrdersList.jsx";
// Proforma Quote — standalone clone of CDN above (own table/number sequence,
// own routes/menu). See models/proformaQuoteModel.js on the backend.
import ProformaQuote from "./pages/ProformaQuote/ProformaQuote.jsx";
import ProformaQuoteList from "./pages/ProformaQuote/ProformaQuoteList.jsx";
import ProformaQuoteHistory from "./pages/ProformaQuote/ProformaQuoteHistory.jsx";
import GenerateProformaQuoteGrn from "./pages/ProformaQuote/GenerateGrn.jsx";
// Credit Notes / Returns list page disabled — credit notes no longer generated.
// import ReturnsList from "./pages/OrderMaster/ReturnsList.jsx";
import DamagedProductsReport from "./pages/OrderMaster/DamagedProductsReport.jsx";
import TransactionHistory from "./pages/OrderMaster/TransactionHistory.jsx";

import ManageCustomer from "./pages/CustomerMaster/Customers.jsx";
import SalesCallAdd from "./pages/SalesCallReport/SalesCallAdd.jsx";
import SalesCallList from "./pages/SalesCallReport/SalesCallList.jsx";
import CustomersList from "./pages/CustomerMaster/CustomersList.jsx";
import StoreAdd from "./pages/StoreMaster/StoreAdd.jsx";
import StoreList from "./pages/StoreMaster/StoreList.jsx";
import InventoryManagement from "./pages/ProductMaster/InventoryManagement.jsx";
import StockTransferReport from "./pages/ProductMaster/StockTransferReport.jsx";
import StockLedgerReport from "./pages/ProductMaster/StockLedgerReport.jsx";
import PurchaseOrderAdd from "./pages/purchaseOrderMaster/purchaseOrderAdd.jsx";
import Vendor1Add from "./pages/Vendor1Masters/Vendor1Add.jsx";
import VendorList1 from "./pages/Vendor1Masters/Vendor1List.jsx";
import StockTransfer from "./pages/ProductMaster/StockTransfer.jsx";
import PurchaseOrderList1 from "./pages/purchaseOrderMaster/purchaseOrderList1.jsx";

import BulkUpload from "./pages/ProductMaster/BulkUpload.jsx";
import StockBulkUpload from "./pages/ProductMaster/StockBulkUpload.jsx";
import StockAdjustmentReport from "./pages/ProductMaster/StockAdjustmentReport.jsx";
import ProductReports from "./pages/OtherMasters/Reports/ProductReports.jsx";
import SalesReports from "./pages/OtherMasters/Reports/SalesReports.jsx";
import ProductSalesReports from "./pages/OtherMasters/Reports/productsalesReports.jsx";
import ProductDetails from "./pages/OtherMasters/Reports/ProductDetails.jsx";
import CustomerStatementList from "./pages/OtherMasters/Reports/CustomerStatementList.jsx";
import CustomerStatementDetail from "./pages/OtherMasters/Reports/CustomerStatementDetail.jsx";
import FocGivenReport from "./pages/OtherMasters/Reports/FocGivenReport.jsx";
import FocApprovals from "./pages/FocManagement/FocApprovals.jsx";
import MissingStockList from "./pages/OtherMasters/Reports/MissingStockList.jsx";
import CreditApprovalList from "./pages/CreditApprovalMaster/CreditApprovalList.jsx";
import StoreInventoryReports from "./pages/OtherMasters/Reports/StoreInventoryReports.jsx";
import ProductStoreReport from "./pages/OtherMasters/Reports/ProductStoreReport.jsx";
import SalesTargetList from "./pages/SalesTargets/SalesTargetList.jsx";
import SalesTargetReport from "./pages/SalesTargets/SalesTargetReport.jsx";

const Layout = () => {
  return <Outlet />;
};

function App() {
  const [role, setRole] = useState("");
  const useRefApp = useRef(false);
  useEffect(() => {
    if (useRefApp.current === false) {
      const useData = JSON.parse(localStorage.getItem("user"));
      if (useData !== null) {
        setRole(useData.role);
      } else {
        if (
          ![FrontentUrl, FrontentUrl + "/adminlogin"].includes(
            window.location.origin
          )
        ) {
          // window.location.href = window.location.origin + "/"
        }
      }
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  return (
    <>
      <TableCellExpander />
      <Routes>
      <Route path="/" element={<Login />} />
      <Route path="adminlogin" element={<AdminLogin />} />

      <Route path="dashboard" element={<RequireAuth menuId={1} />}>
        <Route index element={<DashboardRouter />} />
      </Route>

      <Route path="employee" element={<RequireAuth menuId={6} />}>
        <Route path="add" element={<AddEmployee />} />
        <Route path="list" element={<ListEmployee />} />
        <Route path="view/:employeeid" element={<ViewEmployee />} />
      </Route>

      <Route path="store" element={<RequireAuth menuId={4} />}>
        <Route path="add" element={<StoreAdd />} />
        <Route path="list" element={<StoreList />} />
        <Route path="add/:storeId" element={<StoreAdd />} />
      </Route>

      <Route path="product" element={<RequireAuth menuId={3} />}>
        <Route path="add" element={<Products />} />
        <Route path="bundle-add" element={<BundleProduct />} />
        <Route path="bundle-edit/:id" element={<BundleProduct />} />
        <Route path="bulk-upload" element={<BulkUpload />} />
        <Route path="edit/:id" element={<Products />} />
        <Route path="list" element={<ListProduct />} />
      </Route>

      <Route path="inventory" element={<RequireAuth menuId={3} />}>
        <Route path="add" element={<InventoryManagement />} />
        <Route path="bulk-upload" element={<StockBulkUpload />} />
      </Route>

      <Route path="reports" element={<RequireAuth menuId={7} />}>
        <Route path='stock-report' element ={<StoreInventoryReports /> } />
        <Route path='stock-report/:storeId' element ={<ProductReports /> } />
        <Route path='product-stock/:productId' element ={<ProductStoreReport /> } />
        <Route path='product-details' element ={<ProductDetails /> } />
        <Route path='sales-report' element ={<SalesReports /> } />
        <Route path='sales-report/:productId' element ={<ProductSalesReports /> } />
        <Route path='product-report' element ={<ProductReports /> } />
        <Route path='product-report/:storeId' element ={<ProductReports /> } />
        {/* Stock Transaction Report = the original list of stock transactions. */}
        <Route path="transaction-report" element={<StockTransferReport />} />
        <Route path="transfer-report" element={<StockTransferReport />} />
        {/* Stock Ledger = per product/store: stock at start, each movement, stock at end. */}
        <Route path="stock-ledger" element={<StockLedgerReport />} />
        <Route path="adjustment-report" element={<StockAdjustmentReport />} />
        <Route path="customer-statement" element={<CustomerStatementList />} />
        <Route path="customer-statement/:customerId" element={<CustomerStatementDetail />} />
        <Route path="foc-report" element={<FocGivenReport />} />
        <Route path="sales-target-report" element={<SalesTargetReport />} />
      </Route>

      <Route path="sales-targets" element={<RequireAuth menuId={7} />}>
        <Route index element={<SalesTargetList />} />
      </Route>

      {/* FOC (Free of Charge) approvals — gated by Invoice access (2) to
          view; approve/reject buttons only render for whoever also holds
          menu id 12 ("FOC Approval", e.g. Chief Executive). */}
      <Route path="foc" element={<RequireAuth menuId={[2, 12]} />}>
        <Route path="approvals" element={<FocApprovals />} />
      </Route>

      <Route path="missing-stock" element={<RequireAuth menuId={14} />}>
        <Route path="list" element={<MissingStockList />} />
      </Route>

      <Route path="credit-approval" element={<RequireAuth menuId={[2, 12, 13]} />}>
        <Route path="list" element={<CreditApprovalList />} />
      </Route>

      <Route path="stock" element={<RequireAuth menuId={3} />}>
        <Route path="transfer" element={<StockTransfer />} />        
      </Route>

      <Route path="invoice" element={<RequireAuth menuId={2} />}>
        <Route path="add" element={<Orders />} />
        <Route path="edit/:id" element={<Orders />} />
        {/* Read-only — "View" action from FOC Approvals (see Item 8). */}
        <Route path="view-foc/:focRequestId" element={<Orders />} />
        <Route path="list" element={<ListOrder />} />
        <Route path="purchase-list" element={<PurchaseOrderList1 />} />
        <Route path="transaction-report" element={<TransactionHistory />} />
        {/* Credit Notes / Returns page disabled — credit notes no longer generated */}
        {/* <Route path="returns-list" element={<ReturnsList />} /> */}
        <Route path="damaged-report" element={<DamagedProductsReport />} />
      </Route>

      <Route path="proforma-invoice" element={<RequireAuth menuId={9} />}>
        <Route path="add" element={<ProformaInvoice />} />
        <Route path="edit/:id" element={<ProformaInvoice />} />
        <Route path="list" element={<ProformaInvoiceList />} />
        <Route path="history/:id" element={<ProformaInvoiceHistory />} />
        <Route path="grn/:id" element={<GenerateGrn />} />
      </Route>

      {/* Proforma Quote — standalone clone of CDN above (own table/number
          sequence, own menu id 11). */}
      <Route path="proforma-quote" element={<RequireAuth menuId={11} />}>
        <Route path="add" element={<ProformaQuote />} />
        <Route path="edit/:id" element={<ProformaQuote />} />
        <Route path="list" element={<ProformaQuoteList />} />
        <Route path="history/:id" element={<ProformaQuoteHistory />} />
        <Route path="grn/:id" element={<GenerateProformaQuoteGrn />} />
      </Route>

      <Route path="order" element={<RequireAuth menuId={2} />}>
        <Route path="add" element={<Orders />} />
        <Route path="edit/:id" element={<Orders />} />
        <Route path="list" element={<ListOrder />} />
        <Route path="purchase-list" element={<PurchaseOrderList1 />} />
        <Route path="transaction-report" element={<TransactionHistory />} />
      </Route>

      <Route path="purchase-order" element={<RequireAuth menuId={10} />}>
        <Route path="add" element={<PurchaseOrderAdd />} />
        <Route path="edit/:id" element={<PurchaseOrderAdd />} />
        <Route path="list" element={<PurchaseOrderList1 />} />
        <Route path="transaction-report" element={<TransactionHistory />} />
      </Route>

      <Route path="customer" element={<RequireAuth menuId={4} />}>
        <Route path="add" element={<ManageCustomer />} />
        <Route path="edit/:id" element={<ManageCustomer />} />
        <Route path="list" element={<CustomersList />} />
      </Route>

      {/* Call Log menu — gated by menu id 8 (add it to a role's `menus` to
          grant access). Backend still restricts non-managers to own records. */}
      <Route path="sales-call-report" element={<RequireAuth menuId={8} />}>
        <Route path="add" element={<SalesCallAdd />} />
        <Route path="edit/:id" element={<SalesCallAdd />} />
        <Route path="list" element={<SalesCallList />} />
      </Route>

      <Route path="vendor" element={<RequireAuth menuId={4} />}>
        <Route path="add" element={<Vendor1Add />} />
        <Route path="list" element={<VendorList1 />} />
        <Route path="add/:vendorid" element={<Vendor1Add />} />
      </Route>

      <Route path="config" element={<RequireAuth menuId={5} />}>
        <Route path="positions-master" element={<AddPositons />} />
        <Route path="departments-master" element={<AddDepartments />} />
        <Route path="configuration" element={<Configuration />} />
        <Route path="labour-wages" element={<LabourWages />} />
        <Route
          path="labour-wages/edit/:labourId"
          element={<LabourWagesEdit />}
        />
      </Route>

      <Route path="terms" element={<RequireAuth menuId={4} />}>
        <Route path="add/:orderType" element={<TermsConditions />} />
        <Route path="list/:orderType" element={<TermsConditionsList />} />
        <Route path="add/:orderType/:termsID" element={<TermsConditions />} />
      </Route>

      <Route path="manage-companies" element={<RequireAuth menuId={5} />}>
        <Route path="add" element={<ManageCoAdd />} />
        <Route path="list" element={<ManageCoList />} />
        <Route path="edit/:companyId" element={<ManageCoEdit />} />
      </Route>
      </Routes>
    </>
  );
}

export default App;
